import React, { forwardRef } from 'react';
import DatePickerInput from 'react-datepicker';
import ErrorContainer from '../../ErrorContainer/ErrorContainer';
import { StyledLabel, StyledLabelRow } from './DatePicker.styles';
import { Text14Regular } from '../../Text/Text.styles';
import { useMediaQuery } from 'react-responsive';

const DatePicker = forwardRef(
  (
    {
      value,
      onChange,
      error,
      hideErrorMessage,
      label,
      className,
      disabled,
      placeholder,
      showTimeSelect,
      ...inputProps
    },
    ref,
  ) => {
    const smallScreen = useMediaQuery({ minWidth: 0, maxWidth: 768 });

    return (
      <StyledLabel disabled={disabled} className={className} $showTimeSelect={showTimeSelect}>
        {label && <StyledLabelRow>{label && <Text14Regular>{label}</Text14Regular>}</StyledLabelRow>}
        <DatePickerInput
          ref={ref}
          wrapperClassName="datePicker"
          selected={value}
          onChange={onChange}
          showTimeSelect={showTimeSelect}
          dateFormat={showTimeSelect ? 'dd/MM/yyyy HH:mm' : 'dd/MM/yyyy'}
          disabled={disabled}
          placeholderText={placeholder}
          shouldCloseOnSelect
          onFocus={e => {
            if (smallScreen) {
              e.target.blur();
            }
          }}
          {...inputProps}
        />
        {!hideErrorMessage && <ErrorContainer errorText={error} />}
      </StyledLabel>
    );
  },
);

export default DatePicker;
